//This is a map with key = maxPlayers and data = number[]. number[].length = number of rows,
// each element inside the number[] is the amount of players in that row

import { BetPosition } from '@/features/poker-table/components/UserPanel/UserPanel';

const userPlayerConfig = {
  // classes: "mx-auto h-[5vw] items-center md:h-10 md:mb-0 lg:-mb-[4%]",
  classes: 'mx-auto h-10 items-center -mb-[6%]',
  config: [{ seatPosition: 0, betPosition: BetPosition.Top }],
};

interface SeatConfiguration {
  seatPosition: number;
  betPosition: BetPosition;
}

const TableSeatStructure = new Map<number, { classes: string; config: SeatConfiguration[] }[]>();

TableSeatStructure.set(2, [
  {
    classes: 'mx-auto h-0 -mt-8',
    config: [{ seatPosition: 1, betPosition: BetPosition.Bottom }],
  },
  userPlayerConfig,
]);

TableSeatStructure.set(3, [
  {
    classes: 'w-6/12 h-0 -mt-8',
    config: [
      { seatPosition: 1, betPosition: BetPosition.Bottom },
      { seatPosition: 2, betPosition: BetPosition.Bottom },
    ],
  },
  userPlayerConfig,
]);

TableSeatStructure.set(5, [
  {
    classes: 'w-6/12 h-0 -mt-8',
    config: [
      { seatPosition: 2, betPosition: BetPosition.Bottom },
      { seatPosition: 3, betPosition: BetPosition.Bottom },
    ],
  },
  {
    classes: `w-full h-3/6`,
    config: [],
  },
  {
    classes: `w-[115%] h-1/6`,
    config: [
      { seatPosition: 1, betPosition: BetPosition.Right },
      { seatPosition: 4, betPosition: BetPosition.Left },
    ],
  },
  {
    classes: `w-full h-3/6`,
    config: [],
  },
  userPlayerConfig,
]);

TableSeatStructure.set(6, [
  {
    classes: 'mx-auto h-0 -mt-8',
    config: [{ seatPosition: 3, betPosition: BetPosition.Bottom }],
  },
  {
    classes: `w-full h-1/6`,
    config: [
      { seatPosition: 2, betPosition: BetPosition.BottomRight },
      { seatPosition: 4, betPosition: BetPosition.BottomLeft },
    ],
  },
  {
    classes: `w-full h-3/6`,
    config: [],
  },
  {
    classes: `w-full h-1/6`,
    config: [
      { seatPosition: 1, betPosition: BetPosition.TopRight },
      { seatPosition: 5, betPosition: BetPosition.TopLeft },
    ],
  },
  userPlayerConfig,
]);

TableSeatStructure.set(7, [
  {
    classes: 'w-6/12 h-0 -mt-8',
    config: [
      { seatPosition: 3, betPosition: BetPosition.Bottom },
      { seatPosition: 4, betPosition: BetPosition.Bottom },
    ],
  },
  {
    classes: `w-[115%] h-5/6`,
    config: [
      { seatPosition: 2, betPosition: BetPosition.Right },
      { seatPosition: 5, betPosition: BetPosition.Left },
    ],
  },
  {
    classes: 'w-full h-1/6 ',
    config: [
      { seatPosition: 1, betPosition: BetPosition.TopRight },
      { seatPosition: 6, betPosition: BetPosition.TopLeft },
    ],
  },
  { ...userPlayerConfig, classes: `${userPlayerConfig.classes}` },
]);

TableSeatStructure.set(8, [
  {
    classes: 'h-0 -mt-8',
    config: [{ seatPosition: 4, betPosition: BetPosition.Bottom }],
  },
  {
    classes: 'w-10/12 h-15',
    config: [
      { seatPosition: 3, betPosition: BetPosition.BottomRight },
      { seatPosition: 5, betPosition: BetPosition.BottomLeft },
    ],
  },
  {
    classes: `w-[115%] h-full`,
    config: [
      { seatPosition: 2, betPosition: BetPosition.Right },
      { seatPosition: 6, betPosition: BetPosition.Left },
    ],
  },
  {
    classes: 'w-10/12 h-0 mb-6',
    config: [
      { seatPosition: 1, betPosition: BetPosition.TopRight },
      { seatPosition: 7, betPosition: BetPosition.TopLeft },
    ],
  },
  { ...userPlayerConfig, classes: `${userPlayerConfig.classes} h-12` },
]);

TableSeatStructure.set(9, [
  {
    classes: 'w-5/12 h-0 -mt-8',
    config: [
      { seatPosition: 4, betPosition: BetPosition.Bottom },
      { seatPosition: 5, betPosition: BetPosition.Bottom },
    ],
  },
  {
    classes: 'w-[105%] h-0 -mt-[3%]',
    config: [
      { seatPosition: 3, betPosition: BetPosition.BottomRight },
      { seatPosition: 6, betPosition: BetPosition.BottomLeft },
    ],
  },
  {
    classes: `w-[115%] h-2/6`,
    config: [
      { seatPosition: 2, betPosition: BetPosition.Right },
      { seatPosition: 7, betPosition: BetPosition.Left },
    ],
  },
  {
    classes: 'w-[95%] h-0 -mb-[6%]',
    config: [
      { seatPosition: 1, betPosition: BetPosition.TopRight },
      { seatPosition: 8, betPosition: BetPosition.TopLeft },
    ],
  },
  userPlayerConfig,
]);

export default TableSeatStructure;
